export default "/_next/static/images/d157951f525e7fae148ea244653ac345.jpg";